module.exports = __webpack_public_path__ + "static/img/pinpai-22.ec0a18ad.png";